import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import AnimatedFloatingWhatsApp from './AnimatedFloatingWhatsApp';

function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const location = useLocation();
  
  // Get current page from pathname
  const getCurrentPage = () => {
    const pathname = location.pathname;
    if (pathname === '/') return 'home';
    if (pathname === '/tentang') return 'tentang';
    if (pathname === '/company-profile') return 'company-profile';
    if (pathname === '/portfolio') return 'portfolio';
    if (pathname === '/client') return 'client';
    if (pathname === '/consultation') return 'consultation';
    if (pathname === '/google-ads') return 'google-ads';
    if (pathname === '/services') return 'services';
    if (pathname === '/pricing') return 'pricing';
    if (pathname === '/website-maintenance') return 'website-maintenance';
    if (pathname === '/blog') return 'blog';
    return 'home';
  };

  // Close on ESC, unlock body scroll, and handle resize
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setMobileOpen(false); };
    const onResize = () => { if (window.innerWidth >= 901) setMobileOpen(false); };
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);
    if (mobileOpen) document.body.classList.add('no-scroll'); else document.body.classList.remove('no-scroll');
    return () => {
      document.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
      document.body.classList.remove('no-scroll');
    };
  }, [mobileOpen]);

  // Close services submenu when mobile panel closes
  useEffect(() => {
    if (!mobileOpen) {
      setServicesOpen(false);
      setMobileServicesOpen(false);
    }
  }, [mobileOpen]);

  // Global theme and mode functions
  useEffect(() => {
    window.__setAppTheme = (theme) => {
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
      const buttons = document.querySelectorAll('.socials button, .theme-selector button');
      buttons.forEach(btn => {
        btn.classList.remove('is-active');
        if (btn.classList.contains(theme)) btn.classList.add('is-active');
      });
    };

    window.__setAppMode = (mode) => {
      document.documentElement.setAttribute('data-mode', mode);
      localStorage.setItem('mode', mode);
      const buttons = document.querySelectorAll('.socials button, .theme-selector button');
      buttons.forEach(btn => {
        btn.classList.remove('is-active');
        if (btn.classList.contains(mode)) btn.classList.add('is-active');
      });
    };

    return () => {
      delete window.__setAppTheme;
      delete window.__setAppMode;
    };
  }, []);

  return (
    <div className="App">
      <header className="header">
        <div className="logo" aria-label="PT Cakra Digital Innovation - Technology Solutions & Digital Transformation Company">
          <a href="/" className="site-logo" aria-label="Beranda PT Cakra Digital Innovation">
            <img 
              src={`${process.env.PUBLIC_URL}/cakra_digital_innovation.png`} 
              alt="PT Cakra Digital Innovation - Technology Solutions & Digital Transformation Company" 
              className="site-logo__img"
            />
            <div className="site-logo__text">
              <span className="site-logo__line--top">Cakra Digital</span>
              <span className="site-logo__line--bottom">Innovation</span>
            </div>
          </a>
        </div>
        <button
          className={`hamburger ${mobileOpen ? 'is-active' : ''}`}
          aria-label="Toggle navigation"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
        <Navigation 
          currentPage={getCurrentPage()} 
          mobileOpen={mobileOpen} 
          setMobileOpen={setMobileOpen} 
          servicesOpen={servicesOpen} 
          setServicesOpen={setServicesOpen}
          mobileServicesOpen={mobileServicesOpen}
          setMobileServicesOpen={setMobileServicesOpen}
        />
      </header>

      <main className="main">
        <Outlet />
      </main>

      <AnimatedFloatingWhatsApp />
      <Footer />
    </div>
  );
}

export default Layout;
